import React from "react";
import BluetoothDisabledIcon from "@material-ui/icons/BluetoothDisabled";
import { useTheme } from "@material-ui/styles";
import { Box, Theme, Typography } from "@material-ui/core";
import { Record, useLocale, useTranslate } from "react-admin";
import { HosDriverDto } from "../../../common/data/service-proxies";
import { formatDuration, parseISO } from "date-fns";
import { intervalToDuration } from "date-fns/esm";
import HelpIcon from "@material-ui/icons/Help";
import {
  dateFnsLocaleMap,
  ProLogsLocale,
} from "../../../common/util/localization";
import { enUS } from "date-fns/locale";

interface Props {
  record?: HosDriverDto & Record;
}

export const DriverEldDisconnectedField = ({ record }: Props) => {
  const theme: Theme = useTheme();
  const translate = useTranslate();
  let disconnectedSince = new Date();
  const locale = useLocale() as ProLogsLocale;
  const dateFnsLocale = !!dateFnsLocaleMap[locale]
    ? dateFnsLocaleMap[locale]
    : enUS;

  if (record?.eldDisconnectedSince) {
    disconnectedSince = parseISO(record.eldDisconnectedSince);
  }

  const duration = intervalToDuration({
    start: disconnectedSince,
    end: new Date(),
  });
  return record?.eldConnected === null ? (
    <div>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gridColumnGap={5}
      >
        <HelpIcon
          fontSize="small"
          style={{ color: theme.palette.warning.main }}
        />
        <Typography variant="body2">
          {translate("resources.drivers.labels.unknown")}
        </Typography>
      </Box>
    </div>
  ) : (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gridColumnGap={5}
    >
      <BluetoothDisabledIcon style={{ color: theme.palette.error.main }} />
      <Typography variant="body2">
        {formatDuration(duration, { locale: dateFnsLocale })}
      </Typography>
    </Box>
  );
};
